<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 md9 sm11>
          <h3 class="text-center">Edit Home-Based HealthCare for Patient</h3>
          <v-card class="elevation-24">
            <v-card-title class="py-0">
              <v-spacer></v-spacer>
              <v-btn text small @click.stop.prevent="goTo('/home-based-care/' + homebased.id )" :href="'/home-based-care/' + homebased.id ">
                <v-icon left>mdi-cancel</v-icon>Cancel
              </v-btn>
            </v-card-title>
            <v-card-text>
              <form ref="createhomebased" @submit.prevent="saveHome(homebased)">
                <v-autocomplete label="Select Client" :items="clients" v-model="homebased.client_id" item-text="name" item-value="id" required="required" prepend-inner-icon="mdi-clipboard-account-outline"></v-autocomplete>
                <h4>Assessment Guidelines</h4>
                <v-combobox label="Patient history" prepend-inner-icon="mdi-history" :items="histories" v-model="homebased.history" placeholder="Select one or add new one"></v-combobox>
                <v-textarea prepend-inner-icon="mdi-clipboard-list" auto-grow :rows="2" label="History of presenting illness / condition" v-model="homebased.history_details" placeholder="Give as much details as possible"></v-textarea>
                <v-combobox label="Condition of patient" v-model="homebased.condition" :items="conditions" placeholder="Critical, Fair, etc"></v-combobox>
                <v-combobox prepend-inner-icon="mdi-clock-outline" label="Duration of current illness / condition" v-model="homebased.history_duration" :items="durations"></v-combobox>
                <v-combobox prepend-inner-icon="mdi-stethoscope" label="Areas of Care Needed" v-model="homebased.area_of_care" :items="cares"></v-combobox>
                <v-textarea prepend-inner-icon="mdi-clipboard-list-outline" label="Special Instructions" :rows="2" v-model="homebased.special_instruction" auto-grow placeholder="(drugs, labs, specialist review, allergies etc)"></v-textarea>
                <v-combobox prepend-inner-icon="mdi-clock-alert" label="Duration of Care Needed" v-model="homebased.duration_of_care_needed" :items="durations"></v-combobox>
                <h4>Assessment Report</h4>
                <v-textarea label="Report" placeholder="Write your report here ..." v-model="homebased.report" auto-grow :rows="3"></v-textarea>
                <h4>Care Plan Guide</h4>
                <v-textarea label="Nursing Diagnosis" v-model="homebased.nursing_diagnosis" auto-grow :rows="1"></v-textarea>
                <v-textarea label="Overall Objective" v-model="homebased.overall_objective" auto-grow :rows="1"></v-textarea>
                <v-textarea label="Goals" v-model="homebased.goals" auto-grow :rows="1"></v-textarea>
                <v-textarea label="Interventions" v-model="homebased.interventions" auto-grow :rows="1"></v-textarea>
                <v-textarea label="Evaluation / Review" v-model="homebased.evaluation" auto-grow :rows="1"></v-textarea>
                <v-btn x-small @click="provider = !provider">{{ provider ? 'Use my Professional Account' : 'Assign to Provider' }}
                  <v-icon right>{{ provider ? 'mdi-account' : 'mdi-stethoscope' }}</v-icon>
                </v-btn>
                <v-select prepend-inner-icon="mdi-doctor" label="Provider" :items="professionals" v-model="homebased.professional_id" v-if="provider" item-value="id" item-text="name"></v-select><br>
                <v-btn small class="primary pull-right" type="submit" :loading="saving">
                  Next
                  <v-icon right>mdi-arrow-right-bold</v-icon>
                </v-btn><br>
              </form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'

  export default {
    name: 'EditHomeBased',
    layout,
    props: [
      'professionals', 'clients', 'home-based-care'
    ],
    metaInfo () {
      return {
        title: 'Edit Home-Based Healthcare',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        homebased: this.homeBasedCare,
        histories: [{  header: 'Select an option or create one' }, 'Surgical', 'Medical', 'Gynaecological', 'Allergies'],
        conditions: [{  header: 'Select an option or create one' }, 'Critical', 'Fair', 'Stable'],
        durations: [{  header: 'Select an option or create one' }, '1 month', '2 years'],
        cares: [{ header: 'Select an option or create one'}, 'Nursing', 'Nutrition', 'Physiotherapy', 'Occupational Therapy', 'Palliative Care', 'Post-discharge', 'Covid Care', 'Wound Care'],
        provider: false,
        saving: false,
      }
    },
    methods: {
      saveHome (homebased) {
        swal({
          title: '',
          text: 'Update home-based care plan?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'lime',
          confirmButtonText:'Update',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        },
        function () {
          this.saving = true;
          this.$inertia.put('/home-based-care/' + homebased.id, homebased, {
            onFinish: () => {
              this.saving = false
              swal.close()
            }
          })
        }.bind(this))
      }
    },
    watch: {
      'provider': function (value) {
        if (!value) {
          delete this.homebased.professional_id
        }
      },
    }
  }
</script>
